import React from 'react';
import Autosuggest from 'react-autosuggest';
import LoadingSpinner from './LoadingSpinner';

export default class AutocompleteSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            suggestions: []
        };

    }

    onChange(event, { newValue }) {
        this.props.updateLabel(newValue);
        if((newValue && this.props.value) || !newValue) {
            this.props.update(this.props.propertyName, '');
        }
    }

    onSuggest(suggestion) {
        this.setState({
            suggestions: this.props.options.filter(o =>
                o.value.toLowerCase().indexOf(suggestion.value.toLowerCase()) >= 0)
        });
    }

    onSelectSuggestion(event, { suggestion }) {
        this.props.updateLabel(suggestion.value);
        this.props.update(this.props.propertyName, suggestion.key);
    }

    clearSuggestions() {
        this.setState({
            suggestions: []
        });
    }

    render() {
        return (
            <div>
                {this.props.title && <label className="input-label">{this.props.title}</label>}
                <div className={`search-input ${this.props.className}`} >
                    <i className="material-icons">search</i>
                    <Autosuggest
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this.onSuggest.bind(this)}
                        onSuggestionsClearRequested={this.clearSuggestions.bind(this)}
                        getSuggestionValue={s => s.value}
                        onSuggestionSelected={this.onSelectSuggestion.bind(this)}
                        renderSuggestion={s => <span key={s.key}>{s.value}</span>}
                        inputProps={{
                            tabIndex: this.props.tabindex || '',
                            disabled: this.props.disabled || (!this.props.loading && !this.props.options.length),
                            placeholder: (!this.props.loading && !this.props.options.length) ? this.props.disabledPlaceholder : this.props.placeholder,
                            className: this.props.className,
                            value: this.props.label,
                            onChange: this.onChange.bind(this)
                        }}
                    />
                    {this.props.loading && <LoadingSpinner height="12" />}
                    {(!this.props.value && this.props.label && !this.state.suggestions.length) && <span className="error-label">No suggestions</span>}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/AutocompleteSelect.jsx